(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["be-physio-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('be-physio-campaign-window')) {
    customElements.define('be-physio-campaign-window', class extends HTMLElement {
      connectedCallback() {
        const expire = () => this.closest('.shopify-section')?.remove();
        const delay = Number(this.dataset.expiresAt) - Date.now();
        if (delay <= 0) expire();
        else this.expiryTimer = setTimeout(expire, delay);
      }
      disconnectedCallback() { clearTimeout(this.expiryTimer); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
